import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idUser: number;
};

export const getAccountBalance = async (params: Params): Promise<number> => {
  const fetchURL = getM8AdminURL(
    `getAccountBalance?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
